// pages/doctors/DoctorDetail.js

import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Card, Table, message } from 'antd';
import dayjs from 'dayjs';
import API_BASE_URL from '../../utils/config';


const DoctorDetail = () => {
  const { id } = useParams();
  const [doctor, setDoctor] = useState(null);
  const [payments, setPayments] = useState([]);
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchDoctorDetails();
  }, []);

  const fetchDoctorDetails = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/doctors/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDoctor(res.data.doctor);
      setPayments(res.data.payments || []);
    } catch (err) {
      console.error('Error fetching doctor details:', err);
      message.error('Failed to load doctor details');
    }
  };

  const columns = [
    {
      title: 'Amount (₹)',
      dataIndex: 'amount',
    },
    {
      title: 'Payment Mode',
      dataIndex: 'payment_mode',
    },
    {
      title: 'Remark',
      dataIndex: 'remark',
    },
    {
      title: 'Date',
      dataIndex: 'payment_date',
      render: (date) => dayjs(date).format('DD MMM YYYY'),
    },
  ];

  if (!doctor) {
    return <div className="p-4">Loading doctor details...</div>;
  }

  return (
    <div className="p-4 space-y-4">
<Card
  title={
    <div className="flex justify-between items-center">
      <span>Doctor Information</span>
      <Link
        to={`/doctors/edit/${doctor.id}`}
        className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700"
      >
        Edit
      </Link>
    </div>
  }
  className="shadow-md"
>
        <p><strong>Name:</strong> {doctor.name || '—'}</p>
        <p><strong>Phone:</strong> {doctor.phone || '—'}</p>
        <p><strong>Email:</strong> {doctor.email || '—'}</p>
         ₹ {Number(doctor.total_commission || 0).toFixed(2)}
         
        <p><strong>Linked Customers:</strong> {doctor.customers?.map(c => c.name).join(', ') || '—'}</p>
        <p><strong>Total Commission:</strong> ₹{Number(doctor.total_commission || 0).toFixed(2)}</p>
        <p><strong>Total Paid:</strong> ₹{Number(doctor.total_paid || 0).toFixed(2)}</p>
        <p><strong>Balance:</strong> ₹{Number((doctor.total_commission || 0) - (doctor.total_paid || 0)).toFixed(2)}</p>
      </Card>

<Card title="Customer Commission" className="shadow-md">
  {doctor.customers && doctor.customers.length > 0 ? (
    <table className="w-full border text-sm">
      <thead className="bg-gray-100">
        <tr>
          <th className="p-2 text-left">Customer</th>
          <th className="p-2 text-left">Type</th>
          <th className="p-2 text-left">Commission Scope</th>
          <th className="p-2 text-right">Commission %</th>
        </tr>
      </thead>
      <tbody>
        {doctor.customers.map((c) => (
          <tr key={c.customer_id} className="border-t">
            <td className="p-2">
              <Link
                to={`/customers/${c.customer_id}`}
                className="text-blue-600 hover:underline"
              >
                {c.customer_name}
              </Link>
            </td>

            <td className="p-2">
              {c.type || "—"}
            </td>

            <td className="p-2">
              {c.commission_type
                ? c.commission_type.replace("_", " ")
                : "No commission"}
            </td>

            <td className="p-2 text-right">
              {c.commission_value != null ? `${c.commission_value}%` : "—"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div className="text-gray-500">No customers linked</div>
  )}
</Card>


      <Card title="Commission Payments" className="shadow-md">
        <Table
          dataSource={payments}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 5 }}
        />
      </Card>

      <div>
        <Link to="/doctors" className="text-blue-600 hover:underline">← Back to Doctor List</Link>
      </div>
    </div>
  );
};

export default DoctorDetail;
